import axios from 'axios';
import { API_URL } from './constants';
import { isApiUnavailableError, markApiDown, markApiUp } from './apiAvailability';

const apiOrigin = (API_URL || '').replace(/\/$/, '');

function isTrackedApiUrl(url) {
  if (!apiOrigin || !url) return false;
  return String(url).startsWith(apiOrigin);
}

function requestUrl(config) {
  if (!config) return '';
  const url = config.url || '';
  if (String(url).startsWith('http')) return url;
  return `${config.baseURL || ''}${url}`;
}

axios.interceptors.response.use(
  (response) => {
    if (isTrackedApiUrl(requestUrl(response.config))) markApiUp();
    return response;
  },
  (error) => {
    if (isTrackedApiUrl(requestUrl(error?.config))) {
      if (isApiUnavailableError(error)) markApiDown();
      else if (error?.response) markApiUp();
    }
    return Promise.reject(error);
  }
);

if (typeof window !== 'undefined' && !window.__forloopApiAvailabilityFetch) {
  const originalFetch = window.fetch.bind(window);
  window.fetch = async (input, init) => {
    const url = typeof input === 'string' ? input : input?.url;
    const tracked = isTrackedApiUrl(url);
    try {
      const response = await originalFetch(input, init);
      if (tracked) {
        if (response.status === 502 || response.status === 503 || response.status === 504) markApiDown();
        else markApiUp();
      }
      return response;
    } catch (error) {
      if (tracked && error?.name !== 'AbortError') markApiDown();
      throw error;
    }
  };
  window.__forloopApiAvailabilityFetch = true;
}
